import React from 'react';

/**
 * Іконка Пром-оплати (зелений логотип Prom.ua для способу оплати).
 * Використовується в адмінці замовлень біля типу оплати «Пром-оплата».
 */
function PromPaymentIcon({ className = 'pr-1', size = 20, ...props }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      style={{ verticalAlign: 'middle', ...props.style }}
      focusable="false"
      aria-hidden="true"
      {...props}
    >
      <path
        fill="#00D050"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.668 14.018c-.603 2.99-1.858 5.17-3.767 6.536-1.908 1.367-4.261 1.765-7.057 1.193-1.753-.359-3.22-1.06-4.402-2.107-1.182-1.045-1.987-2.365-2.414-3.958-.427-1.594-.446-3.354-.056-5.283.605-3.002 1.856-5.178 3.746-6.523 1.893-1.349 4.248-1.733 7.067-1.157 1.753.359 3.22 1.058 4.405 2.098 1.184 1.04 1.99 2.352 2.42 3.935.427 1.582.446 3.337.058 5.265Zm-12.62-2.58c-.366 1.818-.347 3.255.058 4.306.406 1.054 1.279 1.716 2.616 1.989 1.328.27 2.377.004 3.145-.804.768-.807 1.339-2.125 1.708-3.954.367-1.82.347-3.243-.056-4.273-.403-1.03-1.277-1.68-2.616-1.954-1.328-.27-2.377-.015-3.147.768-.77.784-1.339 2.092-1.708 3.921Z"
      />
    </svg>
  );
}

export default PromPaymentIcon;
